/**
 * The one rule for a number too small to survive its own precision.
 *
 * A share of 0.0234% rendered at one decimal is `0.0%`, which does not read as
 * "a small number" — it reads as "none of them", which is a different answer.
 * Rounding to nothing is only honest when the value *is* nothing.
 *
 * This lives on its own so the Analysis sheet's formatter and the dashboard
 * card's formatter apply the identical rule. They did not: the sheet fell back
 * to significant digits and the card did not, so the same figure read `0.0234%`
 * on the sheet that produced it and `0.0%` on the card published from it —
 * precisely the divergence the precision control exists to remove.
 */

/** Fraction digits below which a non-zero value would render as zero. */
export function roundsToZero(value: number, decimals: number): boolean {
  if (value === 0 || !Number.isFinite(value)) return false;
  return Math.abs(value) < 0.5 / 10 ** decimals;
}

/**
 * A small value written with enough significant digits to stay visible.
 *
 * Three is enough to place the magnitude and short enough for a table cell.
 */
export function formatSmallNumber(value: number, locale?: string): string {
  return value.toLocaleString(locale, { maximumSignificantDigits: 3 });
}
